import { Card } from "common/styleguide/Card";
import React from "react";
import styles from "./SectionBox.scss";

// this is now really just syntactic sugar for
// "I want a card with a heading above it, and I want them to stay together."
export const SectionBox = ({ title, rightTitle, belowTitle, children, ...props }) => (
  <div>
    {title && !rightTitle && <h2 data-heading-alt>{title}</h2>}
    {title && rightTitle && (
      <div className={styles.flexHeader}>
        <h2 data-heading-alt className={styles.flexLeft}>
          {title}
        </h2>
        <div className={styles.flexRight}>{rightTitle}</div>
      </div>
    )}
    {belowTitle}
    <Card {...props}>{children}</Card>
  </div>
);
